import qs from "qs";
import axios from "axios";

export class FeedbackClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/feedbacks/report`;
  }

  async get(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getXls(params) {
    const url = `${this.baseURL}`;
    const requestParams = {
      params,
      headers: {
        Accept: "application/octet-stream",
      },
      responseType: "blob"
    };

    const response = await axios.get(url, requestParams);

    return response;
  }
}
